import { getField, updateField } from 'vuex-map-fields'
import { getCurrentTimezoneForBackend } from '@/utils/timezone'

const getDefaultState = () => ({
  appLanguage: 'en',
  isPolicyAccepted: false,
  mapSettings: {
    hideAllEventsExceptAccepted: false,
    hideReviewedEvents: false,
    hideSmallTrips: false,
    hideViewedTrips: false,
    clusterEvents: false,
    clusterEventTimePeriod: 10000, // ms
    autoScrollManipulatedEvents: true
  },
  mapLocalFilters: {
    isOnlyNano: false,
    timeRangeFilter: {
      isUsed: false,
      filter: null // will be initialized in mapManagerLocalFilters every time on component creation
    }
  },
  videoSettings: {
    videoWidth: 8, // driver video cols
    videoRoadWidth: 8, // road video cols
    autoPlayVideo: false
  },
  timezoneSettings: {
    isActive: false, // will user timezone be used?
    userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone // timezone storage
  }
})

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    updateField
  },
  getters: {
    getField
  }
}
